module.exports = __webpack_public_path__ + "static/media/m_beard_shortboxed_long__square_shadow.70f971f8.png";